import * as apicall from "../components/Apicall";

// Plan-level stats for dashboard
export const getSubscriptionStats = () =>
  apicall.get("subscription-plans/stats");

// List of subscription plans (plan-level, not user-level)
export const getSubscriptionPlans = ({ page = 1, limit = 10, sortBy = "", sortOrder = "asc", status = "", filter = "" } = {}) => {
  let url = `subscription-plans?page=${page}&limit=${limit}`;
  if (sortBy) url += `&sortBy=${sortBy}&sortOrder=${sortOrder}`;
  if (status) url += `&status=${status}`;
  if (filter) url += `&filter=${filter}`;
  return apicall.get(url);
};

// Dropdown data for create modal — same endpoints as Admin Setup page
export const getServiceCategories = (partnerId) =>
  apicall.get(partnerId ? `get_ezp_service?partner_id=${partnerId}` : "get_ezp_service");

export const getPartners = () => apicall.get("partners");

export const getSubCategories = (serviceCategoryId) =>
  apicall.get(`get_ezp_service_types?services=${serviceCategoryId}`);

// Mirrors AdminSetup getServiceOffering: sub category is optional
export const getServiceTypes = (serviceCategoryId, subCategoryId) => {
  let q = "get_ezp_service_offerings";
  if (serviceCategoryId) {
    q += `?services=${serviceCategoryId}`;
    if (subCategoryId) q += `&&service_type=${subCategoryId}`;
  } else if (subCategoryId) {
    q += `?service_type=${subCategoryId}`;
  }
  return apicall.get(q);
};

export const getSessionOptions = () => apicall.get("session-options");

// Create a new subscription plan
export const createSubscription = (data) =>
  apicall.post(data, "subscription-plans");

// Edit an existing subscription plan
export const editSubscription = (data) =>
  apicall.post(data, "edit-subscription-plan");

// Plan detail info
export const getSubscriptionPlanDetail = (planId) =>
  apicall.get(`subscription-plans/${planId}`);

// Users who purchased a specific plan
export const getPlanSubscribers = (planId) =>
  apicall.get(`subscription-plans/${planId}/subscribers`);

// Visit history for a subscription — queries ezp_bookings by subscription_id
export const getUserVisits = (userSubscriptionId) =>
  apicall.get(`subscription-plan-visits/${userSubscriptionId}`);

// Monthly (master) orders of one subscription, each with its payment status and visits
export const getSubscriptionOrders = (userSubscriptionId) =>
  apicall.get(`subscription-orders/${userSubscriptionId}`);

// Inactivate a subscription plan (sets is_active = 0)
export const inactivateSubscription = (data) =>
  apicall.post(data, "inactivate-subscription-plan");

// Reactivate an inactive subscription plan (sets is_active = 1)
export const reactivateSubscription = (data) =>
  apicall.post(data, "reactivate-subscription-plan");

// Preview the pro-rated first payment for a Monthly Recurring plan, as of today
export const getProratePreview = (planId) =>
  apicall.get(`subscription-plans/${planId}/prorate-preview`);

// Record a subsequent month's recurring payment for a subscriber
export const recordSubscriptionPayment = (data) =>
  apicall.post(data, "record-subscription-payment");

// Subscription payment transactions, for the Payments page
export const getSubscriptionPayments = ({ page = 1, limit = 10 } = {}) =>
  apicall.get(`get_ezp_subscription_payments?page=${page}&limit=${limit}`);
